module.exports = ".not-active {\n    pointer-events: none;\n    cursor: default;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/admin/breadcrumbs/breadcrumbs.component.css
// module id = ./src/app/layout/admin/breadcrumbs/breadcrumbs.component.css
// module chunks = main